'use strict';

// EXPORTS //

module.exports = Number.POSITIVE_INFINITY;
